
$(function(){
    var mql = window.matchMedia("(max-width: 1023px)")

    mediaqueryresponse(mql)
  
    mql.addListener(mediaqueryresponse)
  
    function mediaqueryresponse(mql) {
      if (mql.matches) {
        var crumbs = $('.breadcrumb-item')
        if(crumbs.length > 2){
          $('li.breadcrumb-item:first-child')
            .css('margin-right','5px')
            .after('<div class="dropdown"><button class="dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">&#149;&#149;&#149;</button><ul class="dropdown-menu" aria-labelledby="dropdownMenuButton"></ul></div>');
          $('.breadcrumb')
              .find('li.breadcrumb-item:last-child')
              .prevUntil('.dropdown')
              .detach()
              .appendTo('ul.dropdown-menu');
            }else{
              return;
            }   
      }else{
        var firstCrumb = $('.breadcrumb li.breadcrumb-item:first-child');

        $('.breadcrumb').find('.dropdown').find('.dropdown-menu').children('.breadcrumb-item').detach().insertAfter(firstCrumb);
        $('.breadcrumb').find('.dropdown').remove();
        firstCrumb.css('margin', '0');
      } 
    }
});